import React, { Suspense, useState, useRef } from "react";
import {ThemeProvider} from 'react-bootstrap'
import Layout from './Layouts'
import MainAppContext from './MainAppContext'
import i18n from './i18n';
import Loading from './components/Templates/Site/Loading';
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import { getBoardCalendarFilterConfig, getBoardFieldDisplay, getHelpConfig, getLocaleConfig } from "./common/Helpers";
import { _global_appTheme } from "./common/ObjectStructures/Trasnversal";
import jqxCore from 'jqwidgets-scripts/jqwidgets/jqxcore';

import './styles/css/app.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
//import 'jqwidgets-scripts/jqwidgets/styles/jqx.material-purple.css';

import './styles/jqxgrid-theme-ligth.css';


import { useGetSecurityProps } from "./hooks/services/_Transversal/useOfTransversal";
import Login from "./pages/sBook/Login";
import { __enum_SystemPages, __SystemPagesPaths } from "./common/Dictionaries";
import { __OBJECT_STRUCTURE_GetPrivilegeMatrix } from "./common/ObjectStructures/sKPI";
import '../node_modules/@fluentui/react/dist/css/fabric.css';
import { exportToImage } from "./utils/exportTo";
import { BlockingProvider } from "./pages/BlockingProvider";
import { useGetPrivilegeRoles } from "./hooks/services/sPrivilege/useOfPrivilege";
import NotDataAccess from "./pages/NotDataAccess";

function App(props) {
    jqxCore.credits = "A3DD39EC-2280-4BD5-BE79-6F3C14567565"; 
    const NO_ACCESS_PATH = '/NoDataAccess';
    
    const { token: currentAuth } = useSelector((state) => state.auth);
    const exportRef = useRef();
    const [localeConfig, setLocaleConfig] = useState(getLocaleConfig());
    const [helpConfig, setHelpConfig] = useState(getHelpConfig());
    const [boardDataserieDisplayFields, setBoardDataserieDisplayFields] = useState(getBoardFieldDisplay());
    const [boardCalendarFilterConfig, setBoardCalendarFilterConfig] = useState(getBoardCalendarFilterConfig());
    const [pageIsHomeLanding, setPageIsHomeLanding] = useState(window.location.pathname === '/' || window.location.pathname.toLowerCase() === (__SystemPagesPaths[__enum_SystemPages.HomeLanding].text.toLowerCase()));

    const userName = currentAuth !== null && currentAuth.token !== null ? currentAuth.token.userName : "";
    const isNoAccessPage = window.location.pathname.toLowerCase() === NO_ACCESS_PATH;
    const currentToken = currentAuth !== null && currentAuth.token !== null ? currentAuth.token : null;

    const [securityProps, setSecurityProps] = useState(null);
    useGetSecurityProps(currentToken, securityProps, setSecurityProps, isNoAccessPage);

    const [applicationRoles, setApplicationRoles] = useState(null);
    useGetPrivilegeRoles(applicationRoles, setApplicationRoles, true)

    const handleExport = (pageTitle) => {
        exportToImage(exportRef.current, `SG3-ImageExport ${pageTitle}`)
    }

    if (!localStorage.getItem('PARAM_COOKIE_CONFIG_RESET_DONE')) {
        Object.keys(localStorage).forEach(key => {
            if (
                key.startsWith('PARAM_COOKIE_DATASERIES_AGGREGATED') ||
                key.startsWith('PARAM_COOKIE_DATASERIES_GROUPED')
            ) {
                localStorage.removeItem(key);
            }
        });
        localStorage.setItem('PARAM_COOKIE_CONFIG_RESET_DONE', '1');
    }

    const contextStructure = {
        username: userName,
        sg3LegacyPath: currentAuth !== null && currentAuth.token !== null ? currentAuth.token.sG3LPath : "#",
        clientName: currentAuth !== null && currentAuth.token !== null ? currentAuth.token.clientName : "",
        help: { value: helpConfig, setter: setHelpConfig},
        locale: { value: localeConfig, setter: setLocaleConfig },
        exportFunction: handleExport,
        setIspageIsHomeLanding: setPageIsHomeLanding,
        securityProps: securityProps,
        applicationRoles: applicationRoles,
        onlyObserver: currentAuth !== null && currentAuth.token !== null ? currentAuth.token.profile.find(x => x === "Observador") !== undefined : true,
        kpiModule: {
            boardDataserieDisplayFields: {
                value: boardDataserieDisplayFields,
                setter: setBoardDataserieDisplayFields
            },
            boardCalendarFilterConfig: {
                value: boardCalendarFilterConfig,
                setter: setBoardCalendarFilterConfig
            },
        },
    }
  
    i18n.on('languageChanged', (lng) => contextStructure.locale.setter(localeConfig));

    const isMantainerPage = window.location.href.toLowerCase().indexOf('/forms/') !== -1;

    return (
        <>
            <>
                {
                    (currentAuth === null || currentAuth.token === null) ?
                    <>
                        <Suspense fallback={<Loading />}>
                            <Helmet htmlAttributes={{ lang: localeConfig, dir: localeConfig === 'en' ? 'ltr' : 'ltr' }} />
                            <ThemeProvider theme={_global_appTheme} dir={localeConfig === 'en' ? 'ltr' : 'ltr'}>
                                <Login />
                            </ThemeProvider>
                        </Suspense>
                    </> :
                    <BlockingProvider>
                        {
                            isNoAccessPage ?
                            <Suspense fallback={<Loading />}>
                                <Helmet htmlAttributes={{ lang: localeConfig, dir: localeConfig === 'en' ? 'ltr' : 'ltr' }} />
                                <ThemeProvider theme={_global_appTheme} dir={localeConfig === 'en' ? 'ltr' : 'ltr'}>
                                    <div style={ { paddingLeft: "10px", paddingRight: "10px", paddingTop: "160px"}}>
                                        <NotDataAccess />
                                    </div>
                                </ThemeProvider>
                            </Suspense>
                            :
                            ((securityProps !== null && securityProps !== false && currentAuth && currentAuth.isLoggedIn === true)) &&
                            <MainAppContext.Provider value={ contextStructure }>
                                <Suspense fallback={<Loading />}>
                                    <Helmet htmlAttributes={{ lang: localeConfig, dir: localeConfig === 'en' ? 'ltr' : 'ltr' }} />
                                    <ThemeProvider theme={_global_appTheme} dir={localeConfig === 'en' ? 'ltr' : 'ltr'}>
                                        <div className={(isMantainerPage ? "h-100" : "")} ref={exportRef}>
                                            <Layout pageIsHomeLanding={pageIsHomeLanding} />
                                        </div>
                                    </ThemeProvider>
                                </Suspense>
                            </MainAppContext.Provider>
                        }
                    </BlockingProvider>
                }
            </>
            
        </>
    );
}

export default App;